import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";
import { languageHelper } from "../../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function DetailedShiftReport() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const columns = [
    {
      header: languageHelper(defaultLang, "SN") || "SN",
      cell: (row) => row.row.index + 1,
    },

    {
      header: languageHelper(defaultLang, "Date") || "Date",
      accessorKey: "Date",
      cell: (row) => row.row.original.date.split(" ")[0],
    },
    {
      header: languageHelper(defaultLang, "Time") || "Time",
      accessorKey: "time",
    },
    {
      header: languageHelper(defaultLang, "Reference") || "Reference",
      accessorKey: "reference",
    },
    {
      header: languageHelper(defaultLang, "Order Type") || "Order Type",
      accessorKey: "order_type",
    },
    {
      header: languageHelper(defaultLang, "Total Item") || "Total Item",
      accessorKey: "total_items",
    },
    {
      header: languageHelper(defaultLang, "Subtotal") || "Subtotal",
      accessorKey: "subtotal",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper(defaultLang, "Discount") || "Discount",
      accessorKey: "discount",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper(defaultLang, "Service/Delivery Charges") || "Service/Delivery Charges",
      accessorKey: "service_delivery_charge",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper(defaultLang, "Vat") || "Vat",
      accessorKey: "vat",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper(defaultLang, "G. Total") || "G. Total",
      accessorKey: "grand_total",
      cell: (row) => (row.getValue() || 0).toFixed(2),
    },
    {
      header: languageHelper(defaultLang, "Payment Method") || "Payment Method",
      accessorKey: "payment_method",
    },
  ];
  const footerConfig = {
    SN: languageHelper(defaultLang, "Total") || "Total",
    "Total Item": (rows) =>
      rows.reduce((acc, row) => acc + (row.total_items || 0), 0),
    Subtotal: (rows) =>
      rows.reduce((acc, row) => acc + (row.subtotal || 0), 0).toFixed(2),
    Discount: (rows) =>
      rows.reduce((acc, row) => acc + (row.discount || 0), 0).toFixed(2),
    Vat: (rows) =>
      rows.reduce((acc, row) => acc + (row.vat || 0), 0).toFixed(2),
    "G. Total": (rows) =>
      rows.reduce((acc, row) => acc + (row.grand_total || 0), 0).toFixed(2),
  };
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [error, setError] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [selectedPayment, setSelectedPayment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const handleUserSelect = (e) => {
    setSelectedUser(e.value);
  };
  const handlePaymentSelect = (e) => {
    setSelectedPayment(e.value);
  };

  const [selectedOutlet, setSelectedOutlet] = useState();
  const handleOutletSelect = (e) => {
    setSelectedOutlet(e.value);
  };

  const selectButton = [
    {
      placeholder: languageHelper(defaultLang, "User"),
      options: users,
      onChange: handleUserSelect,
    },

    {
      placeholder: languageHelper(defaultLang, "Payment Method"),
      options: paymentMethods,
      onChange: handlePaymentSelect,
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/detailed-shift-report`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: selectedOutlet || user?.user.outlet_id,
          user_id: selectedUser,
          payment_method: selectedPayment,
          from: startDate,
          to: endDate,
        },
      })
      .then((res) => {
        setData(res.data.data);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [
    endDate,
    selectedPayment,
    selectedUser,
    startDate,
    selectedOutlet,
    user?.token,
    user?.user.outlet_id,
  ]);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/user`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedCustomers = res.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(mappedCustomers);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
    axios
      .get(`${apiKey}/api/rms/admin/payment_methods`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
      })
      .then((res) => {
        const mappedPayments = res.data.map((payment) => ({
          value: payment.name,
          label: payment.name,
        }));
        setPaymentMethods(mappedPayments);
        setError(false);
      })
      .catch((err) => {
        setError(err.response.data.message || "Error occured");
      })
      .finally(() => {});
  }, [user?.token, user?.user.outlet_id]);

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={languageHelper(defaultLang, "Detailed Shift Report")}
        selectButton={selectButton}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        downloads={true}
        dateTime={true}
        handleOutletSelect={handleOutletSelect}
        showFooter={true}
        footerConfig={footerConfig}
      />
    </main>
  );
}

export default DetailedShiftReport;
